import { createSelector, select } from '@ngrx/store';
import {
  selectIsPaperlessBannerPreviouslyViewed,
  selectIsPaperlessPagePreviouslyViewed,
} from '../../feature-modules/opt-in/store/opt-in.selectors';
import {
  selectIsPaperlessEnrollable,
  selectProfilePaperlessError,
} from '../../feature-modules/profile/store/selectors/profile.selectors';

/**
 * Returns true when isPaperlessPageEligible; (Note: These are boolean observables, so wrap this in a waitForSourceData or something equivalent to that to ensure that the response is accurate if you care about the initial emission)
 */
export const selectIsPaperlessPageEligible = createSelector(
  selectIsPaperlessEnrollable,
  selectIsPaperlessPagePreviouslyViewed,
  selectProfilePaperlessError,
  (selectIsPaperlessEnrollable, isPaperlessPagePreviouslyViewed, selectProfilePaperlessError) => {
    return selectIsPaperlessEnrollable && !isPaperlessPagePreviouslyViewed && !selectProfilePaperlessError;
  }
);

/**
 * Returns true when isPaperlessPageEligible; (Note: These are boolean observables, so wrap this in a waitForSourceData or something equivalent to that to ensure that the response is accurate if you care about the initial emission)
 */
export const selectIsPaperlessBannerEligible = createSelector(
  selectIsPaperlessEnrollable,
  selectIsPaperlessBannerPreviouslyViewed,
  selectProfilePaperlessError,
  (selectIsPaperlessEnrollable, isPaperlessBannerPreviouslyViewed, selectProfilePaperlessError) =>
    selectIsPaperlessEnrollable && !isPaperlessBannerPreviouslyViewed && !selectProfilePaperlessError
);
